import ForgotPasswordPage from '../pages/ForgotPasswordPage'
import LoginPage from '../pages/LoginPage'
import ResetPasswordPage from '../pages/ResetPasswordPage'
import SetPasswordPage from '../pages/SetPasswordPage'
import { IRoute } from './types'

const routes: IRoute[] = [
  {
    path: '/login',
    name: 'Login Page',
    component: LoginPage,
    exact: true,
  },
  {
    path: '/forgotPassword',
    name: 'Forgot Password',
    component: ForgotPasswordPage,
    exact: true,
  },
  {
    path: '/set-password',
    name: 'Set Password',
    component: SetPasswordPage,
    exact: true,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPasswordPage,
    exact: true,
  },
  {
    path: '/*',
    name: 'Login Page',
    component: LoginPage,
    exact: true,
  },
]

export default routes
